/**
 * @file Defines aliases for complex authorization validations
 */
import auth from '../auth';
import DefaultValidator from '../validators/default-validator';

const alias = {
    default: () => new DefaultValidator('default'),
    guest: () => new DefaultValidator('guest'),
    profile: () => auth.default,
    transactions: {
        refund: () => auth.transactions.add,
        cancel: () => auth.transactions.add,
        void: () => auth.transactions.add,
        reschedule: () => auth.transactions.add,
        dispute: () => auth.transactions.add,
        capture: () => auth.payments.add,
    },
    customers: {
        getAllUpcomingInvoices: () => auth.invoices.read,
    },
    rulesEngine: () => auth.events.read.or(auth.lists.read),
    systemEvents: () => auth.events,
    dashboard: () => auth.reports.read,
    addCustomer: () => auth.customers.add
        .and(auth.paymentCards.read)
        .and(auth.bankAccounts.read),
    mergeCustomers: () => auth.customers.delete,
    editPaymentInstruments: () => auth.paymentCards.edit.and(auth.bankAccounts.edit),
    readPaymentInstruments: () => auth.paymentCards.read.and(auth.bankAccounts.read),
    // todo: when the backend will implement the assign
    // please update as auth.customers.edit.and(auth.tags.assign)
    assignTagToCustomer: () => auth.customers.edit
        .and(auth.tags),
    upcomingInvoices: () => auth.subscriptions.read
        .and(auth.invoices.read)
        .and(auth.plans.read)
        .and(auth.products.read),
};

export default alias;
